<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-21 15:35:00
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-04-11 14:00:22
-->
<template>
  <div id='task'>
    <div class="maintitle">回答列表</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span='4'>
        <el-input v-model='keyword' placeholder="请输入搜索关键字" size="mini"></el-input>
      </el-col>
      <el-col :span='4'>
        <el-input v-model='company' placeholder="请输入公司id或公司名称关键字" size="mini"></el-input>
      </el-col>
      <el-select size='mini' v-model='area'>
        <el-option v-for='item in arealist' :key='item.id' :value="item.id" :label="item.value"></el-option>
      </el-select>
      <el-select v-model="type" size="mini" class='margin-left'>
        <el-option label='未完成' :value="1"></el-option>
        <el-option label='已完成' :value="4"></el-option>
      </el-select>
      <el-button @click="page=1;getlist()" size='mini' class="margin-left">搜索</el-button>
      <el-button @click="syncStatus" size='mini' class="margin-left">刷新审核状态</el-button>
    </el-row>
    <el-table :data="list" row-key="mid" border>
      <el-table-column prop="bag_word_id" label="任务id" width="80"></el-table-column>
      <el-table-column prop="headline" label="标题"></el-table-column>
      <el-table-column prop="update_time" label="回答时间" width='160'></el-table-column>
      <el-table-column label="状态" :formatter="formatStatus" width='120'></el-table-column>
      <el-table-column label='操作' width='200'>
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="showAnswer(scope)" v-if="scope.row.status == 6 || scope.row.status==2" size="mini" type='success'>修改</el-button>
            <el-button @click="showReason(scope)" v-if="scope.row.status==2" size="mini" type='waring' class="margin-left">查看原因</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="answerDiv" :show-close="false" :close-on-click-modal="false">
      <el-form :model="answer">
        <el-form-item label='落地页地址' :label-width="formLabelWidth" v-if='answer.bag_word_id==0'>
          <el-input v-model='answer.loc' class="input-with-select">
            <el-select class='answer-task-select' v-model="answer.protocol" slot="prepend">
              <el-option label="http://" value="http://"></el-option>
              <el-option label="https://" value="https://"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="权重" :label-width='formLabelWidth'>
          <el-input v-model='answer.priority' type='number' min='0.1' max='1.0' step='0.1'></el-input>
        </el-form-item>
        <el-form-item label="问答主图" :label-width='formLabelWidth' class="text-left">
          <el-upload class="upload-demo" drag :action="HOST + '/admin.task/uppic'" :multiple="false" name='mainpic' :data="uploadData" :show-file-list="false" :on-success="setMainPic" v-if="answer.mainpic==''">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，宽高比例1:1，建议不大于180*180像素
            </div> -->
          </el-upload>
          <div class="picDiv" v-if="answer.mainpic != ''">
            <img :src="answer.mainpic" alt="" />
            <div class="closebtn" @click="clearMainPic">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="回答摘要" :label-width='formLabelWidth'>
          <el-input v-model='answer.abstract' type='textarea' placeholder="请输入回答摘要内容，必填" maxlength="120" show-word-limit></el-input>
        </el-form-item>
        <el-divider></el-divider>
        回答详情
        <div v-for="(it,index) in answer.paragraph" :key="'paragraph'+index" class='paragraphDiv'>
          <el-form-item label="段落标题" :label-width='formLabelWidth'>
            <el-input v-model='answer.paragraph[index].subTitle' maxlength="24" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="段落主图" class="text-left" :label-width='formLabelWidth'>
            <el-upload class="upload-demo" drag :action="HOST + '/admin.task/uppic'" :multiple="false" :name="'paragraphpic'+index" :data="uploadData" :show-file-list="false" :on-success="setParagraphPic" v-if="answer.paragraph[index].canonicalImage == ''">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传jpg文件，宽高比例1:1，建议不小于300*300像素
              </div>
            </el-upload>
            <div class="picDiv" v-if="answer.paragraph[index].canonicalImage != ''">
              <img :src="answer.paragraph[index].canonicalImage" alt="" />
              <div class="closebtn" @click="clearParagraphPic(index)">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="段落详情" :label-width='formLabelWidth'>
            <el-input v-model='answer.paragraph[index].content' type='textarea'></el-input>
          </el-form-item>
          <el-button @click="delParagraph(index)" type='danger'>删除该段落</el-button>
        </div>
        <div class="padding-large-bottom">
          <el-button @click="addParagraph" type='primary'>添加段落</el-button>
        </div>
        <el-form-item label="资料来源" :label-width='formLabelWidth'>
          <el-input v-model='answer.source'></el-input>
        </el-form-item>
        <el-divider></el-divider>
        商家信息
        <el-form-item label='商家' :label-width="formLabelWidth">
          <el-input v-model='answer.xzhId' class="input-with-select" @change='getCompanyInfo'>
            <el-select class='task-company-select' slot="prepend" v-model='answer.xzhId' @change='getCompanyInfo'>
              <el-option v-for="(item,index) in companylist" :key="index" :label="item.company_name" :value="item.member_id"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label='商家名称' :label-width="formLabelWidth">
          <el-input v-model='answer.provider.name' readonly></el-input>
        </el-form-item>
        联系人信息
        <div v-for="(item,index) in answer.provider.contactPerson" :key="'contact'+index" class="paragraphDiv">
          <el-form-item label='联系人姓名' :label-width="formLabelWidth">
            <el-input v-model='answer.provider.contactPerson[index].name'></el-input>
          </el-form-item>
          <el-form-item label='联系人手机' :label-width="formLabelWidth">
            <el-input v-model='answer.provider.contactPerson[index].cellNumber' type='textarea'></el-input>
          </el-form-item>
          <el-form-item label='联系人座机' :label-width="formLabelWidth">
            <el-input v-model='answer.provider.contactPerson[index].telephone' type='textarea'></el-input>
          </el-form-item>
          <el-form-item class="text-left" label='后续咨询' size="small" :label-width="formLabelWidth">
            <el-radio-group v-model="answer.provider.contactPerson[index].consultation">
              <el-radio-button label="是">接受</el-radio-button>
              <el-radio-button label="否">不接受</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-button @click="delProvider(index)" type='danger'>删除联系人</el-button>
        </div>
        <el-button @click="addProvider" type='primary'>添加联系人</el-button>
        <el-divider></el-divider>
        <el-form-item label='主营行业' :label-width="formLabelWidth">
          <el-input v-model='answer.provider.industry' type='textarea'></el-input>
        </el-form-item>
        <el-form-item label='主营产品' :label-width="formLabelWidth">
          <el-input v-model='answer.provider.businessScope' type='textarea'></el-input>
        </el-form-item>
        <el-form-item label="logo" class="text-left" :label-width='formLabelWidth'>
          <el-upload class="upload-demo" drag :action="HOST + '/admin.task/uppic'" :multiple="false" name="logoUrl" :data="uploadData" :show-file-list="false" :on-success="setLogo" v-if="answer.provider.logoUrl == ''">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg文件，宽高比例1:1，建议不小于170*170像素，不能大于4.5M
            </div>
          </el-upload>
          <div class="picDiv" v-if="answer.provider.logoUrl != ''">
            <img :src="answer.provider.logoUrl" alt="" />
            <div class="closebtn" @click="clearLogo">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="answerDiv = false">取 消</el-button>
        <el-button type="primary" @click="answerTask">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      type: 1,
      keyword:'',
      company:'',
      page: 1,
      total: 0,
      crntscope: "",
      first: true,
      answerDiv: false,
      answer: {
        loc: "",
        protocol: "http://",
        priority: 1,
        headline: "",
        bag_word_id: 0,
        mainpic: "",
        abstract: "",
        paragraph: [
          {
            subTitle: "",
            canonicalImage: "",
            content: "",
          },
        ],
        source: "",
        xzhId: "",
        provider: {
          name: "",
          contactPerson: [
            {
              name: "",
              cellNumber: "",
              telephone: "",
              consultation: "是",
            },
          ],
          industry: "",
          businessScope: "",
          logoUrl: "",
        },
      },
      uploadData: {
        adminuuid: sessionStorage.getItem("adminuuid"),
        admintoken: sessionStorage.getItem("admintoken"),
      },
      area: "",
      arealist: JSON.parse(sessionStorage.getItem("arealist")),
    };
  },
  computed: {
    companylist() {
      return this.crntscope == "" ? [] : this.crntscope.row.company;
    },
  },
  methods: {
    getlist() {
      this.$axios({
        url: this.HOST + "/admin.task/getanswerlist",
        method: "post",
        data: {
          type: this.type,
          page: this.page,
          pagesize: this.pagesize,
          area: this.area,
          keyword:this.keyword,
          company:this.company
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
        }
      });
    },
    showReason(scope){
      this.$alert(scope.row.failReason,'错误原因',{
        confirmButtonText:'关闭'
      })
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    formatStatus(row) {
      let info = "";
      switch (parseInt(row.status)) {
        case 1:
          info = "审核完成";
          break;
        case 2:
          info = "审核拒绝";
          break;
        case 3:
          info = "审核完成";
          break;
        case 4:
          info = "建库完成";
          break;
        case 6:
          info = "待审核";
          break;
        default:
          info = "未知";
      }
      return info;
    },
    showAnswer(scope) {
      this.crntscope = scope;
      this.$axios({
        url: this.HOST + "/admin.task/getAnswer",
        method: "post",
        data: {
          bag_word_id: scope.row.bag_word_id,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          for (let item in res.data.answer) {
            this.answer[item] = res.data.answer[item];
          }
          this.answerDiv = true;
        }
      });
    },
    answerTask() {
      this.$axios({
        url: this.HOST + "/admin.task/mdfyanswer",
        method: "post",
        data: {
          answer: this.answer,
          area:this.area
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: "success",
            message: "提交成功",
          });
          this.answer = {
            loc: "",
            protocol: "http://",
            priority: 1,
            headline: "",
            bag_word_id: 0,
            mainpic: "",
            abstract: "",
            paragraph: [
              {
                subTitle: "",
                canonicalImage: "",
                content: "",
              },
            ],
            source: "",
            xzhId: "",
            provider: {
              name: "",
              contactPerson: [
                {
                  name: "",
                  cellNumber: "",
                  telephone: "",
                  consultation: "是",
                },
              ],
              industry: "",
              businessScope: "",
              logoUrl: "",
            },
          };
          this.answerDiv = false;
        }
      });
    },
    setMainPic(res) {
      if (res.status == 1) {
        this.answer.mainpic = res.url;
      } else {
        this.$message({
          type: "error",
          message: res.info,
        });
      }
    },
    setParagraphPic(res) {
      if (res.status == 1) {
        let index = res.name.replace("paragraphpic", "");
        this.answer.paragraph[index].canonicalImage = res.url;
      } else {
        this.$message({
          type: "error",
          message: res.info,
        });
      }
    },
    clearMainPic() {
      this.answer.mainpic = "";
      // this.$axios({
      //   url: this.HOST + '/admin.task/delpic',
      //   method: 'post',
      //   data: {
      //     pic: this.answer.mainpic
      //   }
      // }).then(res => {
      //   if (res.data.status == 1) {
      //     this.answer.mainpic = '';
      //   }
      // })
    },
    setLogo(res) {
      if (res.status == 1) {
        this.answer.provider.logoUrl = res.url;
      } else {
        this.$message({
          type: "error",
          message: res.info,
        });
      }
    },
    clearLogo() {
      this.answer.mainpic = "";
      return;
      this.$axios({
        url: this.HOST + "/admin.task/delpic",
        method: "post",
        data: {
          pic: this.answer.provider.logoUrl,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.answer.provider.logoUrl = "";
        }
      });
    },
    clearParagraphPic(index, op) {
      this.answer.paragraph[index].canonicalImage = "";
      return;
      op = arguments[1] ? arguments[1] : false; //op为真是返回删除结果，为假时不返回结果
      if (this.answer.paragraph[index].canonicalImage == "") return true;
      this.$axios({
        url: this.HOST + "/admin.task/delPic",
        method: "post",
        data: {
          pic: this.answer.paragraph[index].canonicalImage,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.answer.paragraph[index].canonicalImage = "";
          if (op) {
            return true;
          }
        } else {
          return false;
        }
      });
    },
    addParagraph() {
      this.answer.paragraph.push({
        subTitle: "",
        canonicalImage: "",
        content: "",
      });
    },
    delParagraph(index) {
      this.answer.paragraph.splice(index, 1);
      if (this.answer.paragraph.length == 0) {
        this.addParagraph();
      }
      // if (this.clearParagraphPic(index, true)) {
      //   this.answer.paragraph.splice(index, 1);
      //   if (this.answer.paragraph.length == 0) {
      //     this.addParagraph();
      //   }
      // } else {
      //   this.$message({
      //     type: 'error',
      //     message: '操作失败'
      //   })
      // }
    },
    addProvider() {
      this.answer.provider.contactPerson.push({
        name: "",
        cellNumber: "",
        telephone: "",
        consultation: "是",
      });
    },
    delProvider(index) {
      this.answer.provider.contactPerson.splice(index, 1);
      if (this.answer.provider.contactPerson.length == 0) {
        this.addProvider();
      }
      // if (this.clearParagraphPic(index, true)) {
      //   this.answer.provider.contactPerson.splice(index, 1);
      //   if (this.answer.provider.contactPerson.length == 0) {
      //     this.addProvider();
      //   }
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "操作失败",
      //   });
      // }
    },
    getCompanyInfo() {
      if (!parseInt(this.answer.xzhId)) return;
      this.$axios({
        url: this.HOST + "/admin.task/getCompanyInfo",
        method: "post",
        data: {
          member_id: this.answer.xzhId,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.answer.provider.name = res.data.company_name;
        }
      });
    },
    syncStatus() {
      this.$axios({
        url: this.HOST + "/admin.task/syncAnswerStatus",
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: "success",
            message: res.data.info,
          });
          this.getlist();
        }
      });
    },
  },
  created: function () {
    this.area = this.arealist[0].id;
    this.getlist();
  },
};
</script>
<style>
.recomm-memb-div {
  width: 100%;
}
.recomm-memb-div:nth-child(2n + 1) > li {
  background: #eee;
}
.recomm-memb-div > li {
  float: left;
  line-height: 40px;
  list-style: none;
  padding: 0 10px;
  box-sizing: border-box;
}
.recomm-memb-div > li:nth-child(1) {
  width: 80%;
}
.recomm-memb-div > li:nth-child(2) {
  width: 20%;
  text-align: right;
}
.answer-task-select {
  width: 100px;
}
.task-company-select {
  width: 300px;
}
.picDiv {
  position: relative;
  width: 100%;
  /* height: 100px; */
}
.picDiv > .closebtn {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 15px;
  width: 15px;
  padding: 0;
  display: inline-block;
  line-height: 1;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  font-weight: bold;
  cursor: pointer;
}
.picDiv > img {
  width: 100%;
}
.paragraphDiv {
  margin-bottom: 20px;
  border-bottom: 1px dashed gray;
  padding: 20px 0;
}
.paragraphDiv:last-child {
  border: none;
}
</style>